'use strict';

const { Store } = require("./lib/Reducers");
const { actions } = require("./lib/Actions");

module.exports = {
    Store,
    actions
};